import { useRoles } from '@/hooks/auth/useRoles';

/**
 * Compat wrapper sobre `useRoles()`. Resolve as roles via 4 RPCs SECURITY DEFINER
 * (`is_admin`, `is_developer`, `is_super_admin`, `is_teacher_approved`)
 * compartilhando o cache `['user-roles', userId]`.
 */
export function useUserRoles() {
  const { isAdmin, isDeveloper, isSuperAdmin, isTeacher, loading } = useRoles();
  return { isAdmin, isDeveloper, isSuperAdmin, isTeacher, loading };
}

